import { TSubscriptionLevel } from '../schema/subscription-level';

type FilterBySubscription = { subscriptionLevel: TSubscriptionLevel };

export function filterEntitiesBySubscription<T extends FilterBySubscription>(
  items: T[],
  subscriptionLevel: TSubscriptionLevel,
) {
  return items.filter((i) => i.subscriptionLevel === subscriptionLevel);
}
